// extracted by mini-css-extract-plugin
export var wrap = "text-content-module--wrap--yH02g";